<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This book is dedicated to all leaders in business, managers, teachers, parents, carers and to all those who lead from a place of love for their people. A huge thank you to Dr Kevin Treston for his wonderfully insightful foreword. To all our clients, customers, supporters and friends of Kataholos – my love for you is never ending! And to my dearest mum, Kathleen; and dad, Kevin. You have shown me what a true loving leader is, every day of your lives.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?79c5c3fa